// Env vars exposed to the browser. Bun's HTML bundler statically replaces
// `process.env.BUN_PUBLIC_*` references with the env value at bundle time
// (per the `env = "BUN_PUBLIC_*"` setting in apps/web/bunfig.toml). Any other
// `process.env.X` reference is left as-is, which blows up in the browser
// because `process` doesn't exist there. Only read BUN_PUBLIC_-prefixed vars.
//
// `import.meta.env` is a Vite-ism that doesn't exist in Bun — don't use it.

export const API_URL =
  process.env.BUN_PUBLIC_API_URL ?? "http://localhost:3001";

export const CLERK_PUBLISHABLE_KEY =
  process.env.BUN_PUBLIC_CLERK_PUBLISHABLE_KEY ?? "";
